import React, { useState } from "react";
import { Wrench, Truck, Clock, Phone, MessageSquare } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { STORE } from "@/lib/store";

const SMS_NUMBER = "+14389252419";

export default function ServiceRepair() {
  const { t } = useI18n();
  const [form, setForm] = useState({ name: "", appliance: "", problem: "" });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const sendSms = (e) => {
    e.preventDefault();
    const body = `Bonjour DCS, je m'appelle ${form.name || "(nom)"}. Appareil: ${form.appliance || "(appareil)"}. Problème: ${form.problem || "(description)"}.`;
    window.location.href = `sms:${SMS_NUMBER}?&body=${encodeURIComponent(body)}`;
  };

  const Card = ({ icon: Icon, title, text }) => (
    <div className="flex items-start gap-4 border border-gray-200 bg-white p-6">
      <Icon className="text-brand-red shrink-0" size={26} />
      <div><h4 className="font-semibold text-gray-900">{title}</h4><p className="text-sm text-gray-500 mt-1">{text}</p></div>
    </div>
  );

  return (
    <div className="mx-auto max-w-7xl px-4 py-12" data-testid="service-page">
      <div className="flex items-start gap-4 mb-4">
        <Wrench className="text-brand-red mt-1 shrink-0" size={32} />
        <div>
          <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-tight" data-testid="service-title">{t("service.title")}</h1>
          <p className="text-gray-500 mt-3 max-w-2xl">{t("service.subtitle")}</p>
          <p className="text-gray-700 font-medium mt-2">{t("service.p1")}</p>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-4 mt-10">
        <Card icon={Truck} title={t("service.mobile")} text={t("service.mobileD")} />
        <Card icon={Wrench} title={t("service.allBrands")} text={t("service.allBrandsD")} />
        <Card icon={Clock} title={t("service.fast")} text={t("service.fastD")} />
      </div>

      <div className="mt-12 grid lg:grid-cols-2 gap-10">
        <form onSubmit={sendSms} className="border border-gray-200 bg-white p-8 space-y-5 h-fit" data-testid="service-form">
          <div className="flex items-center gap-2 text-brand-navy"><MessageSquare size={20} className="text-brand-red" /><h3 className="font-heading text-2xl font-extrabold">{t("service.formTitle")}</h3></div>
          <p className="text-sm text-gray-500 -mt-2">{t("service.formSub")}</p>
          <div><label className="block text-sm font-medium mb-1">{t("service.name")}</label><input value={form.name} onChange={set("name")} className="w-full border border-gray-300 px-4 py-3 outline-none focus:border-brand-red" data-testid="service-name" /></div>
          <div><label className="block text-sm font-medium mb-1">{t("service.appliance")}</label><input value={form.appliance} onChange={set("appliance")} className="w-full border border-gray-300 px-4 py-3 outline-none focus:border-brand-red" data-testid="service-appliance" /></div>
          <div><label className="block text-sm font-medium mb-1">{t("service.problem")}</label><textarea value={form.problem} onChange={set("problem")} rows={4} className="w-full border border-gray-300 px-4 py-3 outline-none focus:border-brand-red" data-testid="service-problem" /></div>
          <button type="submit" className="w-full flex items-center justify-center gap-2 bg-brand-red text-white font-semibold py-4 hover:bg-[#b81c14] transition-colors" data-testid="service-send"><MessageSquare size={18} /> {t("service.send")}</button>
        </form>

        <div className="space-y-6">
          <div className="border border-gray-200 bg-brand-navy text-white p-8">
            <h3 className="font-heading text-2xl font-extrabold">{t("service.callUs")}</h3>
            <a href={`tel:${STORE.phoneRaw}`} className="mt-4 inline-flex items-center gap-2 text-brand-yellow text-2xl font-bold hover:underline" data-testid="service-phone"><Phone size={22} /> {STORE.phone}</a>
            <a href={`sms:${SMS_NUMBER}`} className="mt-4 block text-white/80 text-sm hover:text-white" data-testid="service-sms-link">SMS : (438) 925-2419</a>
          </div>
          <div className="border border-gray-200 overflow-hidden h-72">
            <iframe title="carte" width="100%" height="100%" style={{ border: 0 }} loading="lazy"
              src="https://maps.google.com/maps?q=4100%20rue%20Jarry%20E%20Montreal&t=&z=14&ie=UTF8&iwloc=&output=embed" />
          </div>
        </div>
      </div>
    </div>
  );
}
